"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var protocolVersion = "1.0.0";
var plebbitJsVersion = "0.0.1";
exports.default = {
    PLEBBIT_JS_VERSION: plebbitJsVersion,
    DB_VERSION: 5,
    PROTOCOL_VERSION: protocolVersion,
    USER_AGENT: "/plebbit-js:".concat(plebbitJsVersion, "/")
};
